import React, { useEffect, lazy, Suspense } from "react";
import "./App.css";
import Home from "./pages/home";
import phoneBg from "./phone-bg.jpg";
import ReactGa from "react-ga";
import { BrowserRouter as Router, Route } from "react-router-dom";

// import Cart from "./pages/cart";
const Cart = lazy(() => import("./pages/cart"));
// import Cat from "./pages/categories";
const Cat = lazy(() => import("./pages/categories"));
// import Vegitables from "./pages/veg";
const Vegitables = lazy(() => import("./pages/veg"));
// import Fruits from "./pages/fruits";
const Fruits = lazy(() => import("./pages/fruits"));
// import Kirana from "./pages/kirana";
const Kirana = lazy(() => import("./pages/kirana"));
// import Dairy from "./pages/dairy";
const Dairy = lazy(() => import("./pages/dairy"));
// import Myorder from "./pages/order";
const Myorder = lazy(() => import("./pages/order"));
// import Productdetail from "./pages/product-detail";
const Productdetail = lazy(() => import("./pages/product-detail"));
// import Camera from "./pages/camera";
const Camera = lazy(() => import("./pages/camera"));
// import Login from "./pages/login/login";
const Login = lazy(() => import("./pages/login/login"));
// import Signup from "./pages/login/signup";
const Signup = lazy(() => import("./pages/login/signup"));
// import Address from "./pages/login/address";
const Address = lazy(() => import("./pages/login/address"));
// import Support from "./pages/support";
const Support = lazy(() => import("./pages/support"));
// import Delivery from "./pages/delivery";
const Delivery = lazy(() => import("./pages/delivery"));
// import Payment from "./pages/payment";
const Payment = lazy(() => import("./pages/payment"));
// import Admin from "./pages/admin";
const Admin = lazy(() => import("./pages/admin"));
// import Bakery from "./pages/bakery";
const Bakery = lazy(() => import("./pages/bakery"));
// import Addproduct from "./pages/admin/productForm";
const Addproduct = lazy(() => import("./pages/admin/productForm"));
// import Alluser from "./pages/admin/allUser";
const Alluser = lazy(() => import("./pages/admin/allUser"));
// import Resetpassword from "./pages/login/resetPassword";
const Resetpassword = lazy(() => import("./pages/login/resetPassword"));
// import PrivateRoute from "./pages/login/auth/privateRoute";
const PrivateRoute = lazy(() => import("./pages/login/auth/privateRoute"));
// import AdminRoute from "./pages/login/auth/adminRoute";
const AdminRoute = lazy(() => import("./pages/login/auth/adminRoute"));
// import Allproduct from "./pages/admin/allProduct";
const Allproduct = lazy(() => import("./pages/admin/allProduct"));
// import Searchresult from "./pages/search/nav/SearchResult";
const Searchresult = lazy(() => import("./pages/search/nav/SearchResult"));
// import OrderSuccess from "./pages/order/success";
const OrderSuccess = lazy(() => import("./pages/order/success"));
// import OrderNote from "./pages/order-note";
const OrderNote = lazy(() => import("./pages/order-note"));
// import DeliveryBoy from "./pages/delivery-boy";
const DeliveryBoy = lazy(() => import("./pages/delivery-boy"));
// import DeliveryBoyRoute from "./pages/login/auth/deliveryBoy";
const DeliveryBoyRoute = lazy(() => import("./pages/login/auth/deliveryBoy"));
// import ProductBySubCat from "./pages/productByCategorie";
const ProductBySubCat = lazy(() => import("./pages/productByCategorie"));
// import OrderById from "./pages/admin/orderById";
const OrderById = lazy(() => import("./pages/admin/orderById"));
// import AboutUs from "./pages/aboutUs";
const AboutUs = lazy(() => import("./pages/aboutUs"));
// import Terms from "./pages/aboutUs/terms";
const Terms = lazy(() => import("./pages/aboutUs/terms"));
// import Privecy from "./pages/aboutUs/privecy";
const Privecy = lazy(() => import("./pages/aboutUs/privecy"));

// import Dryfruits from "./pages/dry-fruits";
const Dryfruits = lazy(() => import("./pages/dry-fruits"));
// import Puja from "./pages/puja/puja";
const Puja = lazy(() => import("./pages/puja/puja"));
// import B2B from "./pages/b2b";
const B2B = lazy(() => import("./pages/b2b"));
// import Birthday from "./pages/birthday";
const Birthday = lazy(() => import("./pages/birthday"));
// import EnterSearchPage from "./component/searchBar/enterSearch";
const EnterSearchPage = lazy(() => import("./components/searchBar/enterSearch"));
// import ProductByNanoCat from "./pages/productByNanoCat";
const ProductByNanoCat = lazy(() => import("./pages/productByNanoCat"));
// import RegisterMyStore from "./pages/RegisteMyStore";
const RegisterMyStore = lazy(() => import("./pages/RegisteMyStore"));
// import ProductByCompany from "./pages/ProductByCompany";
const ProductByCompany = lazy(() => import("./pages/ProductByCompany"));
// import Faq from "./pages/faq";
const Faq = lazy(() => import("./pages/faq"));

// import ReturnPolicy from "./pages/aboutUs/return";
const ReturnPolicy = lazy(() => import("./pages/aboutUs/return"));
// import OrderDetail from "./pages/order/order";
const OrderDetail = lazy(() => import("./pages/order/order"));
// import SetPassword from "./pages/login/setPassword";
const SetPassword = lazy(() => import("./pages/login/setPassword"));

const Membership = lazy(() => import('./pages/membership'))

function App() {
  useEffect(() => {
    ReactGa.initialize("UA-179741116-1");
    // to report page view
    ReactGa.pageview(window.location.pathname + window.location.search);
  }, []);

  const renderProduct = (id) => {
    return <Productdetail id={id} />;
  };

  const orderById = (id) => {
    return <OrderById id={id} />;
  };

  const bySubCat = (subCategorie) => {
    return <ProductBySubCat subCategorie={subCategorie} />;
  };

  const byNanoCat = (nanoCategorie) => {
    return <ProductByNanoCat nanoCat={nanoCategorie} />;
  };

  const searchRender = (categorie, id) => {
    return <Searchresult id={id} categorie={categorie} />;
  };

  const SearchByText = (text) => {
    return <EnterSearchPage text={text} />;
  };

  const SearchByCompany = (company) => {
    return <ProductByCompany company={company} />;
  };

  const OrderByObjId = (objId) => {
    return <OrderDetail objId={objId} />;
  };

  return (
    <Suspense
      fallback={
        <h3>
          <center>Loading..</center>
        </h3>
      }
    >
      <div className="App">
        <Router className="app-router">
          <PrivateRoute path="/my-order" component={Myorder} />
          <PrivateRoute path="/order-success" component={OrderSuccess} />
          <Route path="/cart" component={Cart} />
          <PrivateRoute path="/order-note" component={OrderNote} />
          <PrivateRoute path="/delivery" component={Delivery} />
          <PrivateRoute path="/payment" component={Payment} />
          <PrivateRoute path="/address" component={Address} />
          <Route path="/reset-password" component={Resetpassword} />
          <AdminRoute path="/admin" component={Admin} />
          <AdminRoute path="/all-user" component={Alluser} />
          <AdminRoute path="/add-product" component={Addproduct} />
          <AdminRoute path="/all-products" component={Allproduct} />

          <DeliveryBoyRoute path="/delivery-boy" component={DeliveryBoy} />

          <Route
            path="/product-detail/:id"
            render={(routerProps) => renderProduct(routerProps.match.params.id)}
          />

          <Route
            path="/order-by-id/:ids"
            render={(routerProps) => orderById(routerProps.match.params.ids)}
          />

          <Route
            path="/sub-categorie/:subCategorie"
            render={(routerProps) =>
              bySubCat(routerProps.match.params.subCategorie)
            }
          />

          <Route
            path="/nano-categorie/:nanoCategorie"
            render={(routerProps) =>
              byNanoCat(routerProps.match.params.nanoCategorie)
            }
          />

          <Route
            path="/search/:categorie/:id"
            render={(routerProps) => {
              let categorie = routerProps.match.params.categorie;
              let id = routerProps.match.params.id;
              return searchRender(categorie, id);
            }}
          />

          <Route
            path="/search-query/:text"
            render={(routerProps) => {
              let text = routerProps.match.params.text;
              return SearchByText(text);
            }}
          />

          <Route
            path="/company/:company"
            render={(routerProps) => {
              let company = routerProps.match.params.company;
              return SearchByCompany(company);
            }}
          />

          <Route
            path="/order-detail/:objId"
            render={(routerProps) => {
              return OrderByObjId(routerProps.match.params.objId);
            }}
          />

          <Route path="/bakery" component={Bakery} />
          <Route path="/about-us" component={AboutUs} />
          <Route path="/terms-conditions" component={Terms} />
          <Route path="/privacy-policy" component={Privecy} />

          <Route exact path="/" component={Home} />

          <Route path="/categories" component={Cat} />

          <Route path="/vegetables" component={Vegitables} />

          <Route path="/fruits" component={Fruits} />

          <Route path="/kirana" component={Kirana} />

          <Route path="/dairy" component={Dairy} />

          <Route path="/dry-fruits" component={Dryfruits} />

          <Route path="/puja" component={Puja} />

          <Route path="/shop-on-whatsapp" component={Camera} />

          <Route path="/login" component={Login} />

          <Route path="/signup" component={Signup} />

          <Route path="/support" component={Support} />

          <Route path="/b2b" component={B2B} />

          <Route path="/birthday" component={Birthday} />

          <Route path="/register-my-store" component={RegisterMyStore} />

          <Route path="/faq" component={Faq} />

          <Route path="/return-policy" component={ReturnPolicy} />

          <Route path="/set-password" component={SetPassword} />

          <Route path="/sbg-membership" component={Membership}/>
        </Router>
        
      </div>
    </Suspense>
  );
}

export default App;
